import { Record, Union } from "../fable_modules/fable-library-js.4.25.0/Types.js";
import { record_type, option_type, union_type, string_type, class_type } from "../fable_modules/fable-library-js.4.25.0/Reflection.js";
import { PatientPackageViewModel_get_empty, PatientPackageViewModel_$reflection } from "../ThreeDocs.Models/View/PatientPackageViewModel.js";
import { ErrorMessage_$reflection } from "../ThreeDocs.Models/Api/Api.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.25.0/Result.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExceptionError", "GetPatientPackage", "GetPatientPackageResult"];
    }
}

export function Msg_$reflection() {
    return union_type("ThreeDocs.Client.PatientPackages.Types.Msg", [], Msg, () => [[["Item", class_type("System.Exception")]], [["token", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [PatientPackageViewModel_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", PatientPackageViewModel_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]]]);
}

export class Model extends Record {
    constructor(token, patientPackageVm) {
        super();
        this.token = token;
        this.patientPackageVm = patientPackageVm;
    }
}

export function Model_$reflection() {
    return record_type("ThreeDocs.Client.PatientPackages.Types.Model", [], Model, () => [["token", option_type(string_type)], ["patientPackageVm", union_type("Microsoft.FSharp.Core.FSharpResult`2", [PatientPackageViewModel_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", PatientPackageViewModel_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]]);
}

export function Model_get_empty() {
    return new Model(undefined, new FSharpResult$2(0, [PatientPackageViewModel_get_empty()]));
}

export function Model_get_token_() {
    return [(m) => m.token, (v) => ((m_1) => (new Model(v, m_1.patientPackageVm)))];
}

export function Model_get_patientPackageVm_() {
    return [(m) => m.patientPackageVm, (v) => ((m_1) => (new Model(m_1.token, v)))];
}

